import r from "./highrise1308.mjs";
import s from "./highrise1309.mjs";
function m(n, f, i) {
  (i !== void 0 && !s(n[f], i) || i === void 0 && !(f in n)) && r(n, f, i);
}
export {
  m as default
};
